import React, {
	ComponentPropsWithRef,
	useCallback,
	useEffect,
	useState,
} from 'react';
import { EmblaCarouselType } from 'embla-carousel';

type UsePrevNextButtonsType = {
	prevBtnDisabled: boolean;
	nextBtnDisabled: boolean;
	onPrevButtonClick: (event: React.MouseEvent) => void;
	onNextButtonClick: (event: React.MouseEvent) => void;
};

export const usePrevNextButtons = (
	emblaApi: EmblaCarouselType | undefined,
): UsePrevNextButtonsType => {
	const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
	const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

	const onPrevButtonClick = useCallback(
		(event: React.MouseEvent) => {
			event.stopPropagation();
			if (!emblaApi) return;
			emblaApi.scrollPrev();
		},
		[emblaApi],
	);

	const onNextButtonClick = useCallback(
		(event: React.MouseEvent) => {
			event.stopPropagation();
			if (!emblaApi) return;
			emblaApi.scrollNext();
		},
		[emblaApi],
	);

	const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
		setPrevBtnDisabled(!emblaApi.canScrollPrev());
		setNextBtnDisabled(!emblaApi.canScrollNext());
	}, []);

	useEffect(() => {
		if (!emblaApi) return;

		onSelect(emblaApi);
		emblaApi.on('reInit', onSelect).on('select', onSelect);
	}, [emblaApi, onSelect]);

	return {
		prevBtnDisabled,
		nextBtnDisabled,
		onPrevButtonClick,
		onNextButtonClick,
	};
};

type PropType = ComponentPropsWithRef<'button'>;

export const PrevButton: React.FC<PropType> = ({ children, ...restProps }) => {
	return (
		<button
			type='button'
			{...restProps}>
			{children}
		</button>
	);
};

export const NextButton: React.FC<PropType> = ({ children, ...restProps }) => {
	return (
		<button
			type='button'
			{...restProps}>
			{children}
		</button>
	);
};
